module.exports = new __parcel__URL__("main.ff2998a6.wasm").toString();